// Copyright ©️ 2026 eVolve MEP, LLC

import { useState } from 'react';

import { useEvolveGet } from '@evolvemep/api-ts';
import { Button } from '@mantine/core';

import { isNil } from 'helpers/isNotNil';
import { getActionButtonProps } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/common';
import type { WorkOrderActionButtonsProps } from 'modules/Shop/WorkOrders/WorkOrdersPage/Actions/WorkOrderActionButtons';
import { useWorkOrderModals } from 'modules/Shop/WorkOrders/WorkOrdersPage/modalRegistries';
import { useWorkOrders } from 'modules/Shop/WorkOrders/WorkOrdersPage/useWorkOrders';

export const SubmitWorkOrderButton = ({
  workOrder,
  onWorkOrderUpdated,
  onWorkOrderActioned,
  ...props
}: WorkOrderActionButtonsProps) => {
  const { submitWorkOrder } = useWorkOrders();
  const { openModal } = useWorkOrderModals();
  const [saving, setSaving] = useState(false);

  const { apiCall: getWorkOrder, loading } = useEvolveGet(`shop/workOrder/${workOrder.workOrderId}`);

  const onSubmit = async () => {
    setSaving(true);
    try {
      const wo = await getWorkOrder();
      if (isNil(wo.needByDate)) {
        openModal('needsNeedByModal', {
          workOrder,
          onUpdate: onWorkOrderUpdated,
          onComplete: () => {
            void onSubmit();
          },
        });
      } else {
        await submitWorkOrder(workOrder.workOrderId).then(onWorkOrderActioned);
      }
    } finally {
      setSaving(false);
    }
  };

  return (
    <Button onClick={onSubmit} loading={saving || loading} {...getActionButtonProps(props)}>
      Submit
    </Button>
  );
};
